<template>
  <div id="mechanism" class="table-section">
    <el-card class="box-card" shadow="never">
      <el-button type="primary"  @click="addCustomGroupDialog = true">新增机构</el-button>
    </el-card>
    <div class="table-section">
      <el-table :data="tableData" :header-row-style="headerRowStyle" max-height="550px" border highlight-current-row
        style="width: 100%">
        <el-table-column prop="name" label="名称">
          <template slot-scope="scope">
            <span v-if="!scope.row.isEdit">{{ scope.row.name }}</span>
            <el-input v-else v-model.trim="scope.row.name" />
          </template>
        </el-table-column>
        <el-table-column prop="code" label="代号">

          <template slot-scope="scope">
            <span v-if="!scope.row.isEdit">{{ scope.row.code }}</span>
            <el-input v-else v-model.trim="scope.row.code" />
          </template>
        </el-table-column>
        <el-table-column prop="description" label="描述">

          <template slot-scope="scope">
            <span v-if="!scope.row.isEdit">{{ scope.row.description }}</span>
            <el-input v-else v-model.trim="scope.row.description" />
          </template>
        </el-table-column>
        <el-table-column prop="createuserid" label="创建时间" />
        <el-table-column prop="modifyuserid" label="修改人" />
        <el-table-column prop="createdAt" label="创建时间" />
        <el-table-column label="操作">

          <template slot-scope="scope">
            <el-button v-if="!scope.row.isEdit" type="text" @click="scope.row.isEdit = true">修改</el-button>
            <el-button v-else type="text" @click="InstitutionsEdit(scope.row)">确认</el-button>
            <el-button type="text" @click="addCustomGroup(scope.row)">新增队列</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-section">
      <el-pagination :page-sizes="[5, 10, 15, 20]" :page-size="pageSize" :total="total"
        layout="total, prev, pager, next, sizes" @current-change="changePage" @size-change="sizeChange" />
    </div>
    <!-- 新增队列 -->
    <el-drawer :visible.sync="dialogFormVisible" label-width="80px" title="新增队列">
      <el-form :model="customGroupForm">
        <el-form-item label="客群id">
          <el-input v-model.trim="customGroupForm.customGroupId" />
        </el-form-item>
        <el-form-item label="队列名称">
          <el-input v-model.trim="customGroupForm.name" />
        </el-form-item>
        <el-form-item label="队列简称">
          <el-input v-model.trim="customGroupForm.workQueueName" />
        </el-form-item>
        <el-form-item>
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmAddCustomGroup">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
    <!-- 新增机构 -->
    <el-drawer :visible.sync="addCustomGroupDialog" label-width="80px" title="新增机构">
      <el-form :model="addCustomGroupForm">
        <el-form-item label="机构名称">
          <el-input v-model.trim="addCustomGroupForm.name" />
        </el-form-item>
        <el-form-item label="机构代码">
          <el-input v-model.trim="addCustomGroupForm.code" />
        </el-form-item>
        <el-form-item label="机构描述">
          <el-input v-model.trim="addCustomGroupForm.description" />
        </el-form-item>
        <el-form-item>
          <el-button @click="addCustomGroupDialog = false">取 消</el-button>
          <el-button type="primary" @click="confirmAddInstitutionsEdit">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { InstitutionsList, InstitutionsEdit, addCustomGroup } from '@/api/mechanism.js'
import { mapGetters } from 'vuex'
const moment = require('moment')

export default {
  name: 'mechanism',
  data() {
    return {
      headerRowStyle: {
        'background-color': '#6584b4'
      },
      tableData: [],
      pageSize: 10,
      page: 1,
      total: 0,
      dialogFormVisible: false,
      addCustomGroupDialog: false,
      customGroupForm: {},
      addCustomGroupForm: {}
    }
  },
  computed: {
    ...mapGetters([
      'currentUser'
    ])
  },
  created() {
    this.InstitutionsList()
  },
  methods: {
    /**
     * 获取列表
     */
    async InstitutionsList() {
      const { data: { total, records } } = await InstitutionsList(this.page, this.pageSize)
      records.forEach(item => {
        item.isEdit = false
        if (item.createdAt) item.createdAt = moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')
      })
      this.$set(this, 'tableData', records)
      this.$set(this, 'total', total)
    },
    /**
     * 修改
     */
    async InstitutionsEdit(row) {
      row.modifyuserid = this.currentUser.id
      const { code } = await InstitutionsEdit(row)
      if (code === '00') {
        this.$message.success('操作成功')
        row.isEdit = false
        this.InstitutionsList()
      }
    },
    /**
     * 新增队列
     */
    addCustomGroup({ id }) {
      this.customGroupForm.institutionId = id
      this.dialogFormVisible = true
    },
    /**
     * 确认新增队列
     */
    async confirmAddCustomGroup() {
      if (!this.customGroupForm.customGroupId || !this.customGroupForm.name || !this.customGroupForm.workQueueName) return this.$message.error('请填写完整信息')
      const { code } = await addCustomGroup(this.customGroupForm)
      if (code === '00') {
        this.$message.success('操作成功')
        this.dialogFormVisible = false
        this.customGroupForm = {}
      }
    },
    /**
     * 新增机构
     */
    async confirmAddInstitutionsEdit() {
      if (!this.addCustomGroupForm.name || !this.addCustomGroupForm.code || !this.addCustomGroupForm.description) return this.$message.error('请填写完整信息')
      this.addCustomGroupForm.createuserid = this.currentUser.id
      const { code } = await InstitutionsEdit(this.addCustomGroupForm)
      if (code === '00') {
        this.$message.success('操作成功')
        this.addCustomGroupDialog = false
        this.addCustomGroupForm = {}
        this.InstitutionsList()
      }
    },
    changePage(currentPage) {
      this.page = currentPage
      this.InstitutionsList()
    },
    sizeChange(size) {
      this.page = 1
      this.pageSize = size
      this.InstitutionsList()
    }
  }
}
</script>

<style lang="scss">
.cell {
  text-align: center !important;
}

.el-table {
  thead {

    tr,
    th {
      background-color: #eee;
    }
  }

  tr,
  th {
    text-align: center !important;
  }
}

.table-section {
  margin-top: 20px;
}

.pagination-section {
  margin-top: 20px;
  text-align: center;
}
</style>
